<template>
  <v-container grid-list-md>
    <h1 class="mb-2 headline" v-if="!child">Your Songs</h1>
    <v-data-table hide-actions :headers="headers" :items="songs">
      <template slot="no-data">
        <td v-if="dataLoaded"><v-btn color="primary" :to="{ name: 'CreateSong' }"><v-icon left>fa-plus</v-icon>Create Your First Song</v-btn></td>
        <td v-if="!dataLoaded">Loading songs...</td>
      </template>
      <template slot="items" slot-scope="props">
        <tr :key="props.item.ID">
          <td>
            <router-link :to="{ name: 'EditSong', params: { id: props.item.ID } }">
              {{ props.item.Song }}
            </router-link><br />
            <span class="nl2br">{{ props.item.Motivation }}</span>
          </td>
          <td class="text-xs-center"><v-icon color="secondary" v-if="props.item.DateCompleted !== null">fa-check</v-icon></td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import API from '@/api'

export default {
  props: {
    child: { type: Boolean, default: false },
    dataSent: { type: Boolean, default: false },
    data: { type: Array, default: () => [] }
  },

  data () {
    return {
      dataLoaded: this.dataSent,
      headers: [
        { text: 'Song', value: 'Song', sortable: false },
        { text: 'Completed', value: 'Completed', sortable: false, width: '100px' }
      ],
      songs: this.data
    }
  },

  head: {
    title: function () {
      if (!this.child) {
        return { inner: 'Song List' }
      }
    }
  },

  created () {
    if (!this.child) {
      API.get('songs/all', {
        errorMessage: 'There was an error getting your songs.',
        rollbarMessage: 'Error getting songs',
        success: data => {
          this.dataLoaded = true
          if (data !== undefined && data.Songs !== undefined) {
            this.songs = data.Songs
          }
        }
      }, this)
    }
  }
}
</script>